import React from 'react';
import Contact from '.';
import { AccordionContext } from '@/generic-components/checkout/accordion';
import BypassIfComplete from '@/generic-components/checkout/accordion/bypass-if-complete';
import { AccordionSectionContext } from '@/generic-components/checkout/accordion/section';
import { CheckoutContext } from '../accordion';

export interface ICompleteSection {
  completeSection: (summary: any) => void;
}
const ContactWrapper = () => {
  return (
    <CheckoutContext.Consumer>
      {({ basket, setBasket, checkoutCms, ecProducts }) => (
        <AccordionContext.Consumer>
          {({ neverBypassActiveSection }) => (
            <AccordionSectionContext.Consumer>
              {({ completeSection }) => (
                <BypassIfComplete
                  onBypass={completeSection}
                  isComplete={basket.orderContactInfo ? true : false} // Need to look further
                  neverBypass={neverBypassActiveSection}
                >
                  <Contact
                    basket={basket}
                    setActiveSection={completeSection}
                    setBasket={setBasket}
                    checkoutCms={checkoutCms}
                    ecProducts={ecProducts}
                  />
                </BypassIfComplete>
              )}
            </AccordionSectionContext.Consumer>
          )}
        </AccordionContext.Consumer>
      )}
    </CheckoutContext.Consumer>
  );
};

export default ContactWrapper;
